import { apiResolver, useApi } from "@/api/useApi";
import { useMemo } from "react";

type CustomReportResponse = {
  report: CustomReport;
  startDate: string;
  endDate: string;
  previousReportId?: string;
  nextReportId?: string;
};

type CustomReport = {
  id: string;
  title: string;
  tenantId: string;
  createdAt: string;
  updatedAt: string;
  reportSubscriptionId: string;
  sections: {
    id: string;
    tenantId: string;
    customReportId: string;
    createdAt: string;
    updatedAt: string;
    title: string;
    ticketCount: number;
    keyThemes: string[];
    quotes: string[];
  }[];
};

type NextReportDueResponse = {
  nextRun: string;
};

export function useCustomReportApi() {
  const { api } = useApi();

  return useMemo(
    () => ({
      getReport: async (viewId: string, reportId?: string) => {
        const response = await api.get(
          reportId
            ? `/platform/custom-reports/explore-view/${viewId}/latest-report?reportId=${reportId}`
            : `/platform/custom-reports/explore-view/${viewId}/latest-report`
        );
        if (response.status === 204) {
          return null;
        }
        return response.data as CustomReportResponse;
      },
      getNextReportDue: (viewId: string) =>
        apiResolver<NextReportDueResponse>(
          api.get(`/platform/custom-reports/explore-view/${viewId}/next-run`)
        ),
    }),
    [api]
  );
}
